
import { useCallback } from 'react'
import { PlaceAutocomplete } from './PlaceAutocomplete'
import { UserLocation } from '@/hooks/useUserLocation'
import { GameLocation } from '@/types/game'

interface UserLocationAutocompleteProps {
  value: UserLocation | null
  onChange: (location: UserLocation | null) => void
  placeholder?: string
  className?: string
}

// Adapter component that wraps PlaceAutocomplete to work with UserLocation
export function UserLocationAutocomplete({ 
  value, 
  onChange, 
  placeholder = "Buscar localização...",
  className = ""
}: UserLocationAutocompleteProps) {
  
  // Convert UserLocation to GameLocation for PlaceAutocomplete
  const gameLocation: GameLocation = value ? {
    name: value.mainText,
    address: value.description,
    googlePlaceID: value.placeId,
    coordinate: value.coordinate || { latitude: 0, longitude: 0 }
  } : {
    name: '',
    address: '',
    googlePlaceID: null,
    coordinate: { latitude: 0, longitude: 0 }
  }

  // Convert GameLocation back to UserLocation
  const handleLocationChange = useCallback((gameLocation: GameLocation) => {
    if (gameLocation.name && gameLocation.address && gameLocation.googlePlaceID) {
      // Extract main text and secondary text from address
      const parts = gameLocation.address.split(' - ')
      const mainText = gameLocation.name
      const secondaryText = parts.length > 1 ? parts.slice(1).join(' - ') : gameLocation.address
      
      const userLocation: UserLocation = {
        placeId: gameLocation.googlePlaceID,
        description: gameLocation.address,
        mainText: mainText,
        secondaryText: secondaryText,
        coordinate: {
          latitude: gameLocation.coordinate.latitude,
          longitude: gameLocation.coordinate.longitude
        }
      }
      onChange(userLocation)
    } else {
      onChange(null)
    }
  }, [onChange])

  return (
    <div className={className}>
      <PlaceAutocomplete
        value={gameLocation}
        onChange={handleLocationChange}
        placeholder={placeholder}
        // User-location picker: allow Anchorage/Alaska so the Alaska demo
        // venues (App Store / Play review) are reachable. Criar Jogo and
        // Sugerir Arena use PlaceAutocomplete directly and stay Brazil-only.
        allowAlaska
      />
    </div>
  )
}